if (!customElements.get('urban-image-text')) {
    class UrbanImageTextSlider extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.urban-image-text__content__body__blocks',
          pagination: '.swiper-pagination',
          image: '.urban-image-text__content__body__block__image img',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };
        this.sectionId = this.dataset.sectionId;
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        if (!this.sliderWrapper) return;
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items) || 1;
        this.space = parseInt(this.dataset.space) || 12;
        this.row = parseInt(this.dataset.row) || 1;
        if (!this.enableSlider) return;
        this.updateImageHeightVariable();
        this.init();     
        let resizeTimeout;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            this.init();
            this.updateImageHeightVariable();
          }, 100); 
        });
      }
      
      updateImageHeightVariable() {
        const firstImage = this.querySelector(this.selectors.image);
        if (firstImage) {
          const height = firstImage.offsetHeight;
          document.documentElement.style.setProperty('--image-height', `${height}px`);
        } else {
        }
      }
      init() {
        const isMobile = window.matchMedia('(max-width: 1023px)').matches;
        if (isMobile) {
          this.initSlider();
        } else {
          this.destroySlider();
        }
      }
      initSlider() {
        if (this.swiperInstance) {
          return;
        }
      
        const paginationEl = this.querySelector(this.selectors.pagination);
        if (!paginationEl || !(paginationEl instanceof HTMLElement)) {
          return;
        }
      
        let swiperContainer = this.sliderWrapper.closest('.swiper');
        if (!swiperContainer) {
          swiperContainer = document.createElement('div');
          swiperContainer.classList.add('swiper');
          this.sliderWrapper.parentNode.insertBefore(swiperContainer, this.sliderWrapper);
          swiperContainer.appendChild(this.sliderWrapper);
        }
        this.sliderWrapper.classList.add('swiper-wrapper');
        const slides = this.sliderWrapper.querySelectorAll('.urban-image-text__content__body__block');
        if (slides.length < 1) {
          return;
        }
        slides.forEach(slide => slide.classList.add('swiper-slide'));
        this.swiperInstance = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: this.space,
          pagination: {
            el: paginationEl,
            clickable: true,
          },
          loop: false,
        });
      }
      destroySlider() {
        if (!this.swiperInstance) {
          return;
        }
        this.swiperInstance.destroy();
        this.swiperInstance = null;
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        const slides = this.sliderWrapper.querySelectorAll('.urban-image-text__content__body__block');
        slides.forEach(slide => slide.classList.remove('swiper-slide'));
      }
    }
    customElements.define('urban-image-text', UrbanImageTextSlider);
  }